export default __webpack_public_path__ + "static/media/MADHAVGOPAL.d23bb35c.jpg";